// Mock data for EMC Industrial clone

import {
  Wrench,
  Hammer,
  Truck,
  Container,
  Cog,
  Flame,
  Gauge,
  Droplets,
  ShieldCheck,
  Wind,
} from "lucide-react";

export const BRAND = {
  name: "EMC Industrial",
  fullName: "Engineered Manufacturing Corp.",
  tagline: "Custom Steel & Aluminum Fabrication",
  dealer: "Authorized TATU Marchesan Dealer",
  phone: "305.693.0089",
  phoneHref: "tel:3056930089",
  email: "info@emc-industrial.com",
  address: {
    line1: "3775 Northwest 81st Street",
    line2: "Miami, Florida 33147",
    country: "United States",
  },
  hours: [
    { d: "Mon", h: "07:00 AM – 04:00 PM" },
    { d: "Tue", h: "07:00 AM – 04:00 PM" },
    { d: "Wed", h: "07:00 AM – 04:00 PM" },
    { d: "Thu", h: "07:00 AM – 04:00 PM" },
    { d: "Fri", h: "07:00 AM – 03:30 PM" },
    { d: "Sat", h: "Closed" },
    { d: "Sun", h: "Closed" },
  ],
  socials: {
    facebook: "https://www.facebook.com/",
    instagram: "https://www.instagram.com/",
    linkedin: "https://www.linkedin.com/",
  },
};

export const NAV = [
  { label: "Home", path: "/" },
  {
    label: "TATU Products",
    children: [
      { label: "TATU Disk Harrows", path: "/tatu-disk-harrows" },
      { label: "TATU Assorted Parts", path: "/tatu-assorted-parts" },
      { label: "TATU Replacement Parts", path: "/tatu-replacement-parts" },
    ],
  },
  {
    label: "Products",
    children: [
      { label: "Plasma Cutting Services", path: "/plasma-cutting" },
      { label: "Agricultural Equipment", path: "/agricultural-equipment" },
      { label: "Enclosures", path: "/enclosures" },
      { label: "Fuel Tanks", path: "/fuel-tanks" },
      { label: "Trailers", path: "/trailers" },
    ],
  },
  {
    label: "Tank Parts",
    children: [
      { label: "Gauges, Senders, Switches", path: "/gauges" },
      { label: "Caps & Adaptors", path: "/caps-adaptors" },
      { label: "Spill Containers", path: "/spill-containers" },
      { label: "Vents", path: "/vents" },
    ],
  },
  { label: "For Sale", path: "/for-sale", badge: "NEW" },
  { label: "About", path: "/about" },
];

export const HERO_SLIDES = [
  {
    img: "https://images.unsplash.com/photo-1615811361523-6bd03d7748e7?w=1920&q=80",
    eyebrow: "FORGED IN MIAMI • BUILT TO WORK",
    title: "Engineered Manufacturing",
    subtitle: "Where Steel Meets the Soil.",
    text: "Custom fabrication and authorized TATU Marchesan equipment for the people who keep America moving.",
  },
  {
    img: "https://images.unsplash.com/photo-1698664683348-f9f35b809821?w=1920&q=80",
    eyebrow: "PRECISION WELDING • CERTIFIED CRAFTSMEN",
    title: "Sparks. Steel. Standards.",
    subtitle: "Custom Work, No Shortcuts.",
    text: "From single brackets to full enclosures — we cut, weld, and finish to spec.",
  },
  {
    img: "https://images.unsplash.com/photo-1594771804886-a933bb2d609b?w=1920&q=80",
    eyebrow: "OFFICIAL TATU MARCHESAN DEALER",
    title: "Field-Ready Equipment",
    subtitle: "Backed by Heritage.",
    text: "Disk harrows, replacement parts, and accessories — direct from the source.",
  },
  {
    img: "https://images.pexels.com/photos/12982187/pexels-photo-12982187.jpeg?w=1920",
    eyebrow: "HEAVY DUTY • LONG HAUL",
    title: "Harvest with Confidence.",
    subtitle: "Equipment You Can Trust.",
    text: "Trailers, fuel tanks, and agricultural machinery built for the long season.",
  },
];

export const MARQUEE_TEXT =
  "Visit our new FOR SALE section for great deals on available products";

export const SERVICES = [
  {
    icon: Flame,
    title: "Plasma Cutting Services",
    desc: "High-precision CNC plasma cuts on steel and aluminum up to 1\" thick. Fast turnaround for one-offs and production runs.",
  },
  {
    icon: Cog,
    title: "Agricultural Equipment",
    desc: "TATU Marchesan disk harrows, plows, and tillage tools — built for sugar cane, citrus groves, and row crops.",
  },
  {
    icon: Container,
    title: "Custom Enclosures",
    desc: "Weather-rated steel and aluminum enclosures for generators, pumps, control panels, and electrical gear.",
  },
  {
    icon: Droplets,
    title: "Fuel Tanks",
    desc: "UL-listed above-ground fuel tanks in single and double-wall configurations — sized to your operation.",
  },
  {
    icon: Truck,
    title: "Custom Trailers",
    desc: "Heavy-duty utility and equipment trailers fabricated to spec — built once, built right.",
  },
  {
    icon: Hammer,
    title: "Steel & Aluminum Work",
    desc: "Welding, machining, and custom metal fabrication for industrial, commercial, and agricultural clients.",
  },
];

export const TANK_PARTS = [
  {
    icon: Gauge,
    title: "Gauges, Senders & Switches",
    desc: "Accurate level monitoring components for above and below-ground fuel storage.",
  },
  {
    icon: ShieldCheck,
    title: "Caps & Adaptors",
    desc: "Vapor-tight caps and fill adaptors from trusted industry manufacturers.",
  },
  {
    icon: Droplets,
    title: "Spill Containers",
    desc: "5 to 15-gallon spill buckets engineered to keep fuel out of the ground.",
  },
  {
    icon: Wind,
    title: "Vents",
    desc: "Emergency, pressure, and atmospheric vents for safe tank operation.",
  },
];

export const STATS = [
  { value: "40+", label: "Years in Business" },
  { value: "1,200+", label: "Custom Projects Delivered" },
  { value: "50", label: "States Served" },
  { value: "100%", label: "American-Built" },
];

export const PROCESS = [
  {
    step: "01",
    title: "Consult",
    desc: "Tell us what you’re building. We’ll talk specs, timing, and budget — no fluff.",
  },
  {
    step: "02",
    title: "Engineer",
    desc: "Our team drafts the solution, sources materials, and locks the schedule.",
  },
  {
    step: "03",
    title: "Fabricate",
    desc: "Cutting, welding, finishing — done in-house by craftsmen who care.",
  },
  {
    step: "04",
    title: "Deliver",
    desc: "On-time delivery, on-spec quality. We stand behind every weld.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Carlos M.",
    role: "Farm Operations, Homestead FL",
    quote:
      "EMC rebuilt our entire fuel tank line in under three weeks. Clean welds, on-time, on-budget — these guys are the real deal.",
  },
  {
    name: "Sarah L.",
    role: "Procurement, GreenField Co-op",
    quote:
      "We’ve been buying TATU disk harrows from EMC for years. Best parts support in Florida, hands down.",
  },
  {
    name: "Mike R.",
    role: "Owner, RTL Logistics",
    quote:
      "Custom trailer arrived exactly to spec. The fit and finish is what you’d expect from a shop that’s been doing this for decades.",
  },
];

export const FOR_SALE_DEALS = [
  {
    img: "https://images.unsplash.com/photo-1527847263472-aa5338d178b8?w=800&q=80",
    title: "TATU GAC 20x26 Disk Harrow",
    price: "$24,500",
    tag: "In Stock",
  },
  {
    img: "https://images.unsplash.com/photo-1594771804886-a933bb2d609b?w=800&q=80",
    title: "Custom 500-Gal Fuel Tank",
    price: "$6,890",
    tag: "Ready to Ship",
  },
  {
    img: "https://images.pexels.com/photos/22717514/pexels-photo-22717514.jpeg?w=800",
    title: "Heavy-Duty Utility Trailer",
    price: "$12,200",
    tag: "New Build",
  },
];
